import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';
import { TouchEventService } from '../services/touch-event.service';
import { timer } from 'rxjs/observable/timer';
import { DynamicQuestionService } from '../services/dynamic-question.service';

@Component({
  selector: 'app-esign',
  templateUrl: './esign.component.html',
  styleUrls: ['./esign.component.css']
})
export class EsignComponent implements OnInit {
  
  @ViewChild('redirectForm') redirectForm:ElementRef;
  @ViewChild('isTaxCreditInput') isTaxCreditInput:ElementRef;
  @ViewChild('isCreditInput') isCreditInput:ElementRef;
  @ViewChild('taxBreakGuidInput') taxBreakGuidInput:ElementRef;
  @ViewChild('optedOutInput') optedOutInput:ElementRef;
  @ViewChild('returnCodeInput') returnCodeInput:ElementRef;

  location : Router;
  questions: DynamicQuestionService;
  validationError : boolean;
  _notes : NotificationService;
  sigPlaceholder : string;
  signVerbiage : string = "Electronically Sign";
  submitted : boolean = false;

  constructor(public _location : Router, public _questions: DynamicQuestionService, public swiper : TouchEventService) { 
    this.location = _location;
    this.questions = _questions;
    // this.swiper.publisher.subscribe((args: any) => {
    //   console.log('swiping in direction : ', args);
    //   if(args == 'next')this.continue();
    // })
    
  }
  ngOnInit() {
    // document.getElementsByClassName('container')[0].classList.remove('slide-backward');
    // document.getElementsByClassName('container')[0].classList.add('slide-forward');
    // var tim = timer(0);
    // tim.subscribe(t => {
    //   document.getElementsByClassName('container')[0].classList.remove('slide-forward');
    // })
  }

  accept(){
    // this.questions.screening.acceptedDocuments = !this.questions.screening.acceptedDocuments;
    // console.log(this.questions.screening.acceptedDocuments);
    
  }

  fetchDocument(doc : string) {
      this._questions.FetchPreviewDocument(doc);
      // .subscribe((blob) => {
      //   let blobbo = new Blob([<any>blob], {type: 'application/pdf'});
      //   var dataUrl = window.URL.createObjectURL(blobbo);
      //   window.open(dataUrl);
      // });
  }

  back() : void {
    let lastQuestion = this.questions.flow.filter(e => e.show() == true);
    this.questions.order = lastQuestion[lastQuestion.length-1].order;
    this.location.navigateByUrl('survey');
  }

  continue(){
    // if they did not fill it out then we gotta raise a little flag
    if(!this.questions.screening.eSignature)
    {
      this.validationError = true;
    } else {
      this.signVerbiage = "Submitting..."
      console.log(this.questions.screening);
      let component=this;
      this.questions.SaveScreeningToDatabase().subscribe(res => {
        component.questions.screening.integrationProfile.employeeId = res.integrationProfile.employeeId;
        this.questions.SaveScreeningToDatabase().subscribe(res => {
          this.signVerbiage = 'Forms Submitted!'
          console.log(res);
          if (res.integrationProfile.returnUrl!=null)
          {
            if (res.integrationProfile.returnUrl!="https://screen.synergipartners.com/redirect")
            {
              component.isTaxCreditInput.nativeElement.value=true;
              component.isCreditInput.nativeElement.value=true;
              component.taxBreakGuidInput.nativeElement.value=res.integrationProfile.taxBreakGUID;
              component.optedOutInput.nativeElement.value=false;
              component.returnCodeInput.nativeElement.value="";
              component.redirectForm.nativeElement.action=res.integrationProfile.returnUrl;
              component.redirectForm.nativeElement.submit();
            }
          }
          setTimeout(() => {
            this.submitted = true;
          }, 1000);
        });
      });
    }
  }
  
  help() : void {
    console.log("Sample Tooltip!");
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/esign/esign.component.ts